import { gql, useQuery } from "@apollo/client"
import BookCallBanner from "@pallet/components/BookCallBanner"
import { Box } from "@pallet-hq/hegel"
import { TALENT_WELCOME_QUERY } from "pages/talent/welcome"
import { TalentWelcomeQuery } from "__generated__/TalentWelcomeQuery"
import DetailsSection from "./DetailsSection"
import FallbackVersion from "./FallbackVersion"
import HeroSection from "./HeroSection"
import PreviewSection from "./PreviewSection"
import PricingSection from "./PricingSection"
import { shouldUseFallbackVersion } from "./utils"
import { Modal as CandidateOnboardingModal } from "@pallet/features/onboardingL2/Modal"

const WelcomeFragment = gql`
    fragment TalentWelcome_applylist on ApplylistType {
        id
        ...WelcomeHeroSection_applylist
        ...WelcomePreviewSection_applylist
        ...WelcomeDetailsSection_applylist
        ...WelcomePricingSection_applylist
        ...WelcomeFallbackVersion_applylist
    }
    ${HeroSection.fragment}
    ${PreviewSection.fragment}
    ${DetailsSection.fragment}
    ${PricingSection.fragment}
    ${FallbackVersion.fragment}
`

type WelcomePageProps = {
    slug: string
}

const Welcome = ({ slug }: WelcomePageProps) => {
    const { data, loading, error } = useQuery<TalentWelcomeQuery>(
        TALENT_WELCOME_QUERY,
        {
            variables: { slug },
        }
    )

    if (loading || error || !data?.applylist?.group) return null

    const fallbackVersion = shouldUseFallbackVersion(data.applylist)

    if (fallbackVersion) {
        return (
            <>
                <FallbackVersion applylist={data.applylist} />
                <CandidateOnboardingModal />
            </>
        )
    }

    return (
        <>
            <HeroSection applylist={data.applylist} />
            <PreviewSection applylist={data.applylist} />
            <DetailsSection applylist={data.applylist} />
            {!fallbackVersion && (
                <Box backgroundColor="gray100" pt="large">
                    <BookCallBanner />
                </Box>
            )}
            <CandidateOnboardingModal />
        </>
    )
}

Welcome.fragment = WelcomeFragment
export default Welcome
